import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
// const baseURL = `http://0.0.0.0:8080/`;
const baseURL = `https://us-central1-carmool.cloudfunctions.net/`;

// const headers = {headers: {'Access-Control-Allow-Origin':'*'}};

export const lookupByBarcode = (query) => {
    return trackPromise(axios.post(baseURL+'lookupbybarcode', { barcode: query }));
};

export const addProduct = (query) => {
    return trackPromise(axios.post(baseURL+'addproduct', query));
};